// hooks/useConfirmation.js
import { useState, useCallback } from 'react';
import { emailService } from '../services/emailService';
import { message } from 'antd';

export const useConfirmation = () => {
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [sending, setSending] = useState(false);

  /**
   * Genera y envía confirmación
   */
  const sendConfirmation = useCallback(async (params) => {
    setLoading(true);
    setGenerating(true);

    try {
      const result = await emailService.generateAndSendConfirmation(params);
      return result;
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
      setGenerating(false);
    }
  }, []);

  /**
   * Solo genera el PDF sin enviar
   */
  const generatePDF = useCallback(async (params) => {
    setGenerating(true);

    try {
      const result = await emailService.generateAndSendConfirmation({
        ...params,
        ver: 1 // Solo generar PDF
      });
      return result;
    } catch (error) {
      throw error;
    } finally {
      setGenerating(false);
    }
  }, []);

  /**
   * Solo envía correo (PDF ya generado)
   */
  const sendEmail = useCallback(async (params) => {
    setSending(true);

    try {
      const result = await emailService.sendConfirmationEmail(params);
      return result;
    } catch (error) {
      throw error;
    } finally {
      setSending(false);
    }
  }, []);

  return {
    loading,
    generating,
    sending,
    sendConfirmation,
    generatePDF,
    sendEmail
  };
};